<script>
import _ from 'lodash'
import {
  deepDiffBetweenObjects,
} from "./contract/contract.common";
import BillingServer from '@/api/billing';
import DictionarySelect from "@/components/common/DictionarySelect"
import DictionaryText from '@/components/common/DictionaryText'
// import CronInput from 'vue-cron-generator/src/components/cron-input'
// import { DEFAULT_CRON_EXPRESSION } from 'vue-cron-generator/src/constant/filed'

export default {
  props: {
    source: {
      type: String,
      default: 'contract',
    },
    canEdited: Boolean,
    model: {
      type: Object,
      default: () => { }
    },
    oldModel: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    DictionarySelect,
    DictionaryText,
    // CronInput
  },
  data() {
    return {
      // cron: DEFAULT_CRON_EXPRESSION,
      list: [
        {
          type: 'BILL',
          content: {
            enabled: null,
            billPeriod: null,
            billDay: null,
          }
        }
      ],
      confirmList: [],
      diffList: [],
      termHash: {
        BILL: '账单类型设置',
        enabled: {
          span: 24,
          component: 'el-switch',
          title: '是否启用',
          rules: [
            { required: true, message: '请选择是否启用', trigger: 'change' },
          ],
          props: {
            size: 'small',
          },
        },
        billPeriod: {
          span: 8,
          component: 'dictionary-select',
          originData: {
            component: 'dictionary-text',
            props: {
              params: 'BILLPERIOD',
              factoryName: 'domain',
            }
          },
          title: '账单类型',
          props: {
            size: 'small',
            params: 'BILLPERIOD',
            factoryName: 'domain',
            width100: false,
            clearable: true,
          }
        },
        billDay: {
          span: 16,
          component: 'el-input-number',
          title: ['第', '天开具'],
          tip: '（系统在规定时间的第二天检查账单是否开具）',
          props: {
            size: 'small',
            min: 0,
          }
        }
      }
    }
  },
  watch: {
    'model.id': {
      immediate: true,
      handler(id) {
        this.list = [
          {
            type: 'BILL',
            content: {
              billPeriod: null,
              billDay: null,
            }
          }
        ]
        this.confirmList = []
        this.diffList = []
        if (id) {
          this.getData()
        } else {
          if (this.source !== 'contract') {
            this.list = [{
              type: 'BILL',
              content: {
                enabled: null,
                billPeriod: null,
                billDay: null,
              }
            }]
          } else {
            this.list = [{
              type: 'BILL',
              content: {
                billPeriod: null,
                billDay: null,
              }
            }]
          }
        }
      }
    },
    source: {
      immediate: true,
      handler(source) {
        if (source !== 'contract') {
          this.list = this.list.map(item => ({
            ...item,
            content: { enabled: null, ...item.content }
          }))
        } else {
          this.list = this.list.map(item => {
            Reflect.deleteProperty(item.content, 'enabled')
            return item
          })
        }
      }
    },
    list: {
      immediate: true,
      deep: true,
      handler(list) {
        this.$emit('termChanged', list.map(item => ({
          ...item, content: JSON.stringify({
            billPeriod: item.content.billPeriod,
            billDay: item.content.billDay,
          })
        })))
      }
    }
  },
  mounted() {

  },
  computed: {
    // canEdit() {
    //   return this.model.id ? this.canEdited : true
    // }
  },
  methods: {
    // change(cron) {
    //   this.cron = cron
    // },
    // reset() {
    //   this.cron = DEFAULT_CRON_EXPRESSION
    // },
    has(obj, attr) {
      return _.has(obj, attr)
    },
    getOldData(item, data) {
      if(item.component === 'el-select') {
        return item.options.find(item => item.value === data).label
      } else {
        return data || '-'
      }
    },
    async getData() {
      const { data } = await BillingServer.contract.getContractTermsByContractId(this.model.id)
      const { data: confirmData } = await BillingServer.contract.getConfirmedContractTermsByContractId(this.model.id)
      this.diffList = []
      if (data.data && data.data.length > 0) {
        this.list = data.data.map(item => {
          if (this.source !== 'contract') {
            return ({ ...item, content: { enabled: null, ...JSON.parse(item.content) } })
          }
          return ({ ...item, content: JSON.parse(item.content) })
        })
      } else {
        this.list = []
      }
      if (confirmData.data && confirmData.data.length > 0) {
        this.confirmList = confirmData.data.map(item => {
          if (this.source !== 'contract') {
            return ({ ...item, content: { enabled: null, ...JSON.parse(item.content) } })
          }
          return ({ ...item, content: JSON.parse(item.content) })
        })
      }
      this.list.map((item, index) => {
        const diff = deepDiffBetweenObjects(this.confirmList[index], item)
        if (this.confirmList.length > 0 && !_.isEmpty(diff)) {
          this.diffList.push(deepDiffBetweenObjects(this.confirmList[index], item))
        }
      })
    },
  }
}
</script>

<template>
  <div>
    <div v-for="(term, index) in list" :key="term.type + index">
      <el-form :model="term">
        <el-row class="column-name" justify="start">
          <span>{{ termHash[term.type] || '-' }}</span>
          <div class="navbar-right">
          </div>
        </el-row>

        <el-row>
          <template v-for="(item, key) in termHash">
            <el-col v-if="has(term.content, key)" :key="key" :span="item.span">
              <template v-if="typeof item.title === 'object'">
                <el-form-item label="" :prop="`content.${key}`" :rules="item.rules">
                  <div style="display: flex;flex-direction: row;align-items: center;">
                    <label class="el-form-item__label">{{ item.title[0] }}</label>
                    <div style="margin: 0 10px;">
                      <el-select size="small" v-model="list[index].content[key]"
                                 v-if="item.component === 'el-select'" :disabled="canEdited">
                        <el-option v-for="opt in item.options" :key="opt.value" :value="opt.value"
                                   :label="opt.label" />
                      </el-select>
                      <component
                          v-else
                          :is="item.component"
                          v-bind="item.props"
                          v-model="list[index].content[key]"
                          :disabled="canEdited"
                      ></component>
                    </div>
                    <label class="el-form-item__label">{{ item.title[1] }}</label>
                    <span
                        v-if="source !== 'contract' && item.tip"
                        style="color:red;margin-bottom: 5px;"
                    >
                      {{ item.tip }}
                    </span>
                    <span
                        v-if="source === 'contract' && diffList.length > 0 && has(diffList[index].content, key) && item.originData"
                        class="old-data" >
                        (原：
                        <component
                            :is="item.originData.component"
                            class="old-data"
                            v-bind="item.originData.props"
                            :value="getOldData(item, diffList[index].content[key])"
                        ></component>
                        )
                    </span>
                    <span
                        class="old-data"
                        v-if="source === 'contract' && diffList.length > 0 && has(diffList[index].content, key) && !item.originData">
                        (原：{{ getOldData(item, diffList[index].content[key]) }})
                    </span>
                  </div>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item :label="item.title" :prop="`content.${key}`" :rules="item.rules">
                  <el-select size="small" v-model="list[index].content[key]"
                             v-if="item.component === 'el-select'" :disabled="canEdited">
                    <el-option v-for="opt in item.options" :key="opt.value" :value="opt.value"
                               :label="opt.label" />
                  </el-select>
                  <component
                      v-else
                      :is="item.component"
                      v-bind="item.props"
                      v-model="list[index].content[key]"
                      :disabled="canEdited"
                  ></component>
                  <span
                      v-if="source === 'contract' && diffList.length > 0 && has(diffList[index].content, key) && item.originData"
                      class="old-data" >
                      (原：
                      <component
                          :is="item.originData.component"
                          class="old-data"
                          v-bind="item.originData.props"
                          :value="getOldData(item, diffList[index].content[key])"
                      ></component>
                      )
                  </span>
                  <span
                      class="old-data"
                      v-if="source === 'contract' && diffList.length > 0 && has(diffList[index].content, key) && !item.originData">
                    (原：{{ getOldData(item, diffList[index].content[key]) }})
                  </span>
                </el-form-item>
              </template>
            </el-col>
          </template>
        </el-row>
      </el-form>
    </div>
    <!-- <cron-input v-model="cron" size="small" @change="change" @reset="reset" style="width: 300px;margin-bottom: 10px;"/> -->
  </div>
</template>

<style scoped>
.old-data {
  line-height: 40px;
  color: #e6a23c;
  margin-left: 4px;
}
</style>
<style>
.cron-row {
  max-width: 650px !important;
}
</style>
